import { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

// Renders trusted-but-sanitized Markdown → HTML. `marked` produces HTML; DOMPurify
// strips any XSS vectors before it is injected. Styled via `.prose-cms` (index.css).
export default function MarkdownContent({ markdown = "", className = "" }) {
  const html = useMemo(() => {
    const raw = marked.parse(markdown || "", { gfm: true, breaks: false });
    return DOMPurify.sanitize(raw, { ADD_ATTR: ["target", "rel"] });
  }, [markdown]);

  return (
    <div
      className={`prose-cms ${className}`}
      data-testid="markdown-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
